import { tAssignableType } from 'common/modules/ReactShared/data/api/document/types';
import { AssignmentTaskType, tAssignmentInputType } from './types';

export const TASK_TO_MESSENGER_TYPE_MAP: Record<tAssignableType, tAssignmentInputType> = {
  [AssignmentTaskType.Essay]: 'text',
  [AssignmentTaskType.EssayAI]: 'text',
  [AssignmentTaskType.Audio]: 'audio',
  [AssignmentTaskType.File]: 'file'
};
